/**
 * uiStore — Gerencia estado global da UI (sidebar, modais)
 *
 * Consumidores: DashboardLayout (via hooks)
 * Dependências: nenhuma
 * Persistência: localStorage (bigwa-ui — sidebar state)
 */
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface UIState {
  isSidebarCollapsed: boolean;
  activeModal: string | null;
  openModalCount: number;

  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  openModal: (modalId: string) => void;
  closeModal: () => void;
  registerModal: () => void;
  unregisterModal: () => void;
}

export const useUIStore = create<UIState>()(
  devtools(
    persist(
      (set) => ({
        isSidebarCollapsed: false,
        activeModal: null,
        openModalCount: 0,

        toggleSidebar: () => {
          set((state) => ({
            isSidebarCollapsed: !state.isSidebarCollapsed,
          }));
        },

        setSidebarCollapsed: (collapsed) => {
          set({ isSidebarCollapsed: collapsed });
        },

        openModal: (modalId) => {
          set((state) => ({ activeModal: modalId, openModalCount: state.openModalCount + 1 }));
        },

        closeModal: () => {
          set((state) => ({ activeModal: null, openModalCount: Math.max(0, state.openModalCount - 1) }));
        },

        registerModal: () => {
          set((state) => ({ openModalCount: state.openModalCount + 1 }));
        },

        unregisterModal: () => {
          set((state) => ({ openModalCount: Math.max(0, state.openModalCount - 1) }));
        },
      }),
      {
        name: 'ui-storage',
        partialize: (state) => ({
          isSidebarCollapsed: state.isSidebarCollapsed,
        }),
      }
    ),
    { name: 'UIStore' }
  )
);
